import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { processApplicationData } from "../Utils/utils";
import Overlay from "../../../../SharedComponents/Overlay";
import { getAssessments } from "../../Assessment/Store/Thunk";
import { HandleUpdateOperation, UpdateAssessment, UpdateName } from "../Store";

import { CreateInventory, UpdateInventory, uploadApplicationBackUp } from "../Store/Thunk";

import InventoryList from "./InventoryList/InventoryList";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import { ButtonGroup, ToggleButton } from "react-bootstrap";

export default function Inventory() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoading1 = useSelector((state) => state.inventory.isLoading);
  const isLoading2 = useSelector((state) => state.assessment.isLoading);
  const selectedAssessments = useSelector((state) => state.inventory.selectedAssessments);
  const inventoryId = useSelector((state) => state.inventory.inventoryId);
  const isUpdateOperation = useSelector((state) => state.inventory.isUpdateOperation);
  const name = useSelector((state) => state.inventory.name);
  const inventories = useSelector((state) => state.inventory.inventories);
  const isLoading = isLoading1 || isLoading2;
  const [mappedAssessmentList, setMappedAssessmentList] = useState([]);
  const [isArchiveActive, setIsArchiveActive] = useState(false);

  const assessmentList = useSelector((state) => state.assessment.assessmentList);

  useEffect(() => {
    dispatch(getAssessments());
    setMappedAssessmentList(HandleMappingAssesments());
  }, []);

  const archivedInventories = inventories.filter((inventory) => inventory.isArchive);
  const nonArchivedInventories = inventories.filter((inventory) => !inventory.isArchive);

  const HandleMappingAssesments = () => {
    return (assessmentList || []).map((x) => ({
      label: x.isB2b ? x.name + "B2b" : x.name + "B2c",
      name: x.name,
      id: x.id,
      value: x.id,
    }));
  };

  const submitForm = (event) => {
    event.preventDefault();
    if (!isUpdateOperation) {
      dispatch(
        CreateInventory({
          name,
          assessmentIds: selectedAssessments.map((x) => x.id),
        })
      );
    } else {
      dispatch(
        UpdateInventory({
          name: name,
          assessmentIds: selectedAssessments.map((x) => x.id),
          id: inventoryId,
        })
      );
    }

    event.currentTarget.reset();
    ClearInputs();
  };

  const UploadApplicationBackup = (event) => {
    const file = event.target.files[0];
    const fileReader = new FileReader();

    fileReader.onload = (event) => {
      const content = event.target.result;
      const applicationData = JSON.parse(content);
      const processedData = processApplicationData(applicationData);
      dispatch(uploadApplicationBackUp(processedData));
    };

    if (file) {
      fileReader.readAsText(file);
    }
  };

  const HandleAssessmentSelect = (val) => {
    dispatch(UpdateAssessment(val));
  };

  const ClearInputs = () => {
    dispatch(
      HandleUpdateOperation({
        name: "",
        selectedAssessments: [],
        isUpdateOperation: false,
        inventoryId: 0,
      })
    );
  };

  return (
    <div>
      {isLoading && <Overlay />}
      <Card body className="mb-3 default-card admin-form">
        <Form onSubmit={submitForm}>
          <Row>
            <Col xs={12} md={5}>
              <h6>{t("inventoryName")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  required
                  name="name"
                  placeholder={t("enterInventoryName")}
                  value={name}
                  onChange={(e) => dispatch(UpdateName(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={5}>
              <Row>
                <Col>
                  <h6>{t("Assessments")}</h6>
                </Col>
                <Col xs="auto">
                  {/* A styled label stands in for the native file picker. */}
                  <label className="btn btn-secondary btn-sm mb-2" htmlFor="inventory-backup-input">
                    {t("uploadBackup")}
                  </label>
                  <input
                    id="inventory-backup-input"
                    style={{ display: "none" }}
                    type="file"
                    accept="application/json"
                    onChange={(e) => UploadApplicationBackup(e)}
                  />
                </Col>
              </Row>
              <Select
                classNamePrefix="admin-select"
                value={selectedAssessments}
                options={mappedAssessmentList}
                placeholder={"Değerleme seçiniz"}
                onChange={HandleAssessmentSelect}
                closeMenuOnSelect={false}
                isMulti
              />
            </Col>
            <Col xs={12} md={2} style={{ marginBottom: "0px !important" }}>
              <Row style={{ height: !isUpdateOperation && "100%", margin: 0 }}>
                <Button
                  className="mb-1"
                  type="submit"
                  style={{ width: "100%", height: "100%" }}
                  variant="primary"
                  disabled={!name}
                >
                  {isUpdateOperation ? t("update") : t("create")}
                </Button>
              </Row>
              {isUpdateOperation && (
                <Row style={{ margin: 0 }}>
                  <Button style={{ width: "100%", height: "100%" }} variant="secondary" onClick={ClearInputs}>
                    {t("decline")}
                  </Button>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
      </Card>

      <Row className={"justify-content-between"}>
        <Col xs={"auto"}>
          <h5>
            <span>{isArchiveActive ? t("Archived") : t("NonArchived")}</span>
            <span> {t("inventories")}</span>
          </h5>
        </Col>
        <Col xs={"auto"}>
          <Row className={"mx-0"}>
            <ButtonGroup className="mb-2" size="sm">
              <ToggleButton
                id={"inventory-nonarchived-button"}
                type="radio"
                className={`button align-content-center text-nowrap ${!isArchiveActive ? "success primary" : "secondary bg-white"}`}
                style={{ fontSize: "0.875rem", padding: "0.25rem 0.75rem" }}
                value={"nonarchived"}
                checked={!isArchiveActive}
                onClick={() => setIsArchiveActive(false)}
              >
                {t("NonArchived") + ` (${nonArchivedInventories?.length})`}
              </ToggleButton>
              <ToggleButton
                id={"inventory-archived-button"}
                type="radio"
                className={`button align-content-center text-nowrap ${isArchiveActive ? "success primary" : "secondary bg-white"}`}
                style={{ fontSize: "0.875rem", padding: "0.25rem 0.75rem" }}
                value={"archived"}
                checked={isArchiveActive}
                onClick={() => setIsArchiveActive(true)}
              >
                {t("Archived") + ` (${archivedInventories?.length})`}
              </ToggleButton>
            </ButtonGroup>
          </Row>
        </Col>
      </Row>

      <InventoryList isArchiveActive={isArchiveActive} />
    </div>
  );
}
